import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centotesi20082017',
  templateUrl: './centotesi20082017.component.html',
  styleUrls: ['./centotesi20082017.component.css']
})
export class Centotesi20082017Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
